import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectDataFile } from '../../selectors/datafile'
import { UpdateDataFileForm as Form } from './UpdateDataFileForm'

const mapStateToProps = (state: AppStateType) => ({
  datafile: selectDataFile(state),
})

export const UpdateDataFileForm = connect(mapStateToProps)(Form)
